<template>
  <span class="zm-breadcrumb__item">
    <span
      :class="['zm-breadcrumb__inner', to ? 'is-link' : '']"
      :tabindex="to ? 0 : -1"
      ref="link"
      @click="linkTo"
      @keydown.enter.self="linkTo"
      @keydown.space.self="linkTo"
      role="link"
    >
      <slot></slot>
    </span>
    <i v-if="separatorClass" class="zm-breadcrumb__separator" :class="separatorClass"></i>
    <span v-else class="zm-breadcrumb__separator" role="presentation">{{separator}}</span>
  </span>
</template>
<script>
  export default {
    name: 'ZmBreadcrumbItem',
    props: {
      to: [String, Object],
      replace: Boolean
    },
    data() {
      return {
        separator: '',
        separatorClass: ''
      };
    },

    inject: ['ZmBreadcrumb'],
    methods: {
      linkTo() {
        const { to, $router } = this;
        if (!to || !$router) return;
        this.replace ? $router.replace(to) : $router.push(to);
      }
    },
    mounted() {
      this.separator = this.ZmBreadcrumb.separator;
      this.separatorClass = this.ZmBreadcrumb.separatorClass;
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";
  @import "../../components/button/var";

  @include b(breadcrumb) {
    @include e(item) {
      float: left;
      color: $--button-link-color;
      @include e(inner) {
        float: left;
        max-width: 148px;
        white-space:nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.is-link, & a {
          /*font-weight: bold;*/
          text-decoration: none;
          transition: $--color-transition-base;
          color: $--button-link-color;

          &:hover {
            text-decoration: underline;
            color: $--button-link-hover-color;
            cursor: pointer;
          }
        }
      }

      &:last-child {
        .zm-breadcrumb__inner,
        .zm-breadcrumb__inner a {
          &, &:hover {
            font-weight: normal;
            color: $--color-text-primary;
            cursor: text;
          }
        }

        .zm-breadcrumb__separator {
          display: none;
        }
      }
    }
  }
  .zm-theme--dark {
    @include b(breadcrumb) {
      @include e(item) {
        color: $--button-link-dark-color;
        @include e(inner) {
          &.is-link, & a {
            color: $--button-link-dark-color;

            &:hover {
              color: $--button-link-dark-hover-color;
            }
          }
        }

        &:last-child {
          .zm-breadcrumb__inner,
          .zm-breadcrumb__inner a {
            &, &:hover {
              color: $--color-white;
            }
          }
        }
      }
    }
  }
</style>
